import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { api } from '../api/client';

interface Settings {
  pickupEnabled: boolean;
}

const SettingsContext = createContext<Settings>({ pickupEnabled: true });

export function SettingsProvider({ children }: { children: ReactNode }) {
  const [settings, setSettings] = useState<Settings>({ pickupEnabled: true });

  useEffect(() => {
    api.settings.get()
      .then(setSettings)
      .catch(() => setSettings({ pickupEnabled: true })); // Fallback: alles aktiviert
  }, []);

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings(): Settings {
  return useContext(SettingsContext);
}
